import { useQuery } from "@apollo/client/react";
import { useSearchParams } from "react-router-dom";
import { DependencyTable } from "../../../../components/DependencyTable/DependencyTable";
import { MiddlePageLoading } from "../../../../components/MiddlePageLoading";
import { useAccountContext } from "../../../../strict/app/AccountResolver";
import { CredentialDocument, KeyDetailsDocument } from "../../../../graphql/types";
import type {
  CredentialQuery,
  CredentialQueryVariables,
  KeyDetailsQuery,
  KeyDetailsQueryVariables,
} from "../../../../graphql/types";
import { KeyInformation } from "../../components/KeyInformation";
import { BreadcrumbsInformation, KeyPageHeader } from "../../components/KeyPageHeader";
import { KeyPageWrapper } from "../../components/KeyPageWrapper";
import { SuspendedKeyCard } from "../../components/SuspendedKeyCard";

const KeyDetails = () => {
  const [searchParams] = useSearchParams();
  const keyName = searchParams.get("keyName");

  const { data: dependenciesData, loading: dependenciesLoading } = useQuery<KeyDetailsQuery, KeyDetailsQueryVariables>(
    KeyDetailsDocument,
    {
      variables: {
        keyName: keyName || "",
      },
      fetchPolicy: "cache-and-network",
    }
  );

  const { data, loading: crendentialLoading } = useQuery<CredentialQuery, CredentialQueryVariables>(
    CredentialDocument,
    {
      variables: {
        name: keyName || "",
      },
      fetchPolicy: "cache-and-network",
    }
  );

  const loading = dependenciesLoading || crendentialLoading;

  const { urlName: url_name } = useAccountContext();

  const breadcrumbs: BreadcrumbsInformation[] = [
    {
      name: "Vault",
      link: `/app/${url_name}/keys`,
      "data-testid": "vault-breadcrumb",
    },
    {
      name: "Key details",
    },
  ];

  if (!keyName || !url_name) return null;

  if (loading) return <MiddlePageLoading />;

  return (
    <KeyPageWrapper>
      <KeyPageHeader
        keyName={keyName}
        keyType={data?.credential?.credential_type || ""}
        breadcrumbsInformation={breadcrumbs}
      />
      {data?.credential?.status === "suspended" && (
        <SuspendedKeyCard credential={data?.credential} urlName={url_name} />
      )}
      <DependencyTable
        uploads={dependenciesData?.keyDetails.downloadsUsingKey}
        emptyStateText="No dependencies for this key"
        downloads={dependenciesData?.keyDetails.uploadsUsingKey}
      />
      {data?.credential && <KeyInformation credential={data?.credential} />}
    </KeyPageWrapper>
  );
};
export { KeyDetails };
